import React, { useEffect } from "react"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import "./AmazonInstructionPage.scss";
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"
import TMHFooter from "../../components/TMHFooter/TMHFooter";

export default function AmazonInstructionPage() {
    useTitle("How To Redeem Amazon Rewards - The Movie House TV")

    useEffect(() => {
        ReactGA.send("pageview")
    })

    const iconStep1 = require('./img/icon-step-1.png')
    const iconStep2 = require('./img/icon-step-2.png')
    const iconStep3 = require('./img/icon-step-3.png')
    const iconStep4 = require('./img/icon-step-4.png')

    const step1 = require('./img/step-1.png')
    const step2And3 = require('./img/step-2-3.png')
    const step4 = require('./img/step-4.png')

    const step1Mobile = require('./img/mobile-step-1.png')
    const step2And3Mobile = require('./img/mobile-step-2-3.png')
    const step4Mobile = require('./img/mobile-step-4.png')

    return (
        <TMHBanner styleId={2} classOption="only-gradient">
            <div className="amazon-wrapper">
                <div className="box-1">
                    <div className="block-1">
                        <div className="block-title">
                            <p>
                                Click to claim your
                            </p>
                            <p>
                                Movie, login to your
                            </p>
                            <p className="red-color">
                                Amazon account or create a new account
                            </p>
                        </div>
                    </div>

                    <div className="block-2">
                        <div className="step-rec" />
                        <div className="block-step">
                            <img src={iconStep1} alt="step1" />
                            <div className="step-item">
                                <p className="step-title">
                                    Step 1. Apply
                                </p>
                                <p className="step-des">
                                    Apply the Movie Gift Code provided in the email sent by The Movie House
                                </p>
                            </div>
                        </div>
                        <div className="step-rec" />
                        <div className="block-step">
                            <img src={iconStep2} alt="step2" />
                            <div className="step-item">
                                <p className="step-title">
                                    Step 2. Search 
                                </p>
                                <p className="step-des">
                                    Search and select for your desired Movie
                                </p>
                            </div>
                        </div>
                        <div className="step-rec" />
                        <div className="block-step">
                            <img src={iconStep3} alt="step3" />
                            <div className="step-item">
                                <p className="step-title">
                                    Step 3. Rent
                                </p>
                                <p className="step-des">
                                    Click "Rent" Movie from the Movie options list
                                </p>
                            </div>
                        </div>
                        <div className="block-step">
                            <img src={iconStep4} alt="step4" />
                            <div className="step-item">
                                <p className="step-title">
                                    Step 4. Confirm and play
                                </p>
                                <p className="step-des">
                                    Confirm your rental type. The amount will be taken off your already applied gift code balance.
                                </p>
                            </div>
                        </div>
                        <p className="note">See detailed steps and screens below</p>
                    </div>
                </div>
                <div className="box-2">
                    <div className="box-2-large">
                        <img className="step-1" src={step1} alt="step 1"/>
                        <img className="step-2-3" src={step2And3} alt="step 2, 3" />
                        <img className="step-4" src={step4} alt="step 4" />
                    </div>

                    <div className="box-2-mobile">
                        <img className="step-1-mobile" src={step1Mobile} alt="step-1"/>
                        <img className="step-2-3-mobile" src={step2And3Mobile} alt="step-2-3" />
                        <img className="step-4-mobile" src={step4Mobile} alt="step-4" />
                    </div>
                </div>
                <TMHFooter />
            </div>
        </TMHBanner>
    )
}